import { render, staticRenderFns } from "./CaptionCard.vue?vue&type=template&id=6fbfb81d&scoped=true"
import script from "./CaptionCard.vue?vue&type=script&lang=js"
export * from "./CaptionCard.vue?vue&type=script&lang=js"
import style0 from "./CaptionCard.vue?vue&type=style&index=0&id=6fbfb81d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbfb81d",
  null
  
)

export default component.exports